/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RibbonIcon = ({ width = 24, height = 24, hidden = false, title = 'Ribbon' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M11.776 22.661 7.564 30.24a.5.5 0 0 0 .617.693L12.2 29.5a.5.5 0 0 1 .639.3l1.432 4.016a.5.5 0 0 0 .926.038l1.681-3.708-3.042-6.441a11.429 11.429 0 0 1-2.06-1.044Zm16.66 7.579-3.869-7.807a11.248 11.248 0 0 1-8.218 1.935l4.459 9.49a.5.5 0 0 0 .925-.038l1.432-4.02a.5.5 0 0 1 .64-.3l4.014 1.432a.5.5 0 0 0 .617-.692ZM18 4a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm0 14.5a5.5 5.5 0 1 1 5.5-5.5 5.5 5.5 0 0 1-5.5 5.5Z"
    />
  </svg>`;
};
